////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'

//////STYLED//////
const TelecollectDetailSalePaymentStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => props.colorCode};
	color: ${(props) => props.theme.colors.white};
	line-height: 32px;
	font-weight: bold;
	padding: 0px 10px;
`
//////STYLED//////

const TelecollectDetailSalePaymentStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TelecollectDetailSalePaymentStatusWrapper colorCode={props.row.paymentStatus.colorCode}>
			{translations[props.row.paymentStatus.translationKey]}
		</TelecollectDetailSalePaymentStatusWrapper>
	)
}

TelecollectDetailSalePaymentStatus.propTypes = {}

TelecollectDetailSalePaymentStatus.defaultPropTypes = {}

export default TelecollectDetailSalePaymentStatus
